import { cn } from '@/shared/lib/cn';

type AvatarProps = { initials: string; isWorkspace?: boolean; className?: string };

export function Avatar({ initials, isWorkspace = false, className }: AvatarProps) {
  return (
    <span
      data-slot="avatar"
      aria-hidden="true"
      className={cn(
        'inline-flex size-6 shrink-0 items-center justify-center rounded-avatar font-semibold text-avatar',
        isWorkspace ? 'bg-accent text-accent-ink' : 'bg-surface-3 text-ink',
        className,
      )}
    >
      {initials}
    </span>
  );
}
